<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <DocumentTypeModal ref="dashboardModal"></DocumentTypeModal>

        <LoadCard v-if="load"></LoadCard>

        <doughnut-chart v-else :data="chartData" :options="chartOptions" @click="handleChartClick">
        </doughnut-chart>
    </div>
</template>
<script>
//signal R
import { hub } from '@/plugins/signalR/index';
import { ReceiveHubs, Hubs as namesHub } from '@/plugins/enums/index.js';

//grafica
import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from 'chart.js'

//alerta, tonos de color, modal, load, data
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import tinycolor from 'tinycolor2'
import DocumentTypeModal from './DocumentTypeGraph/Document-type-modal.vue'
import LoadCard from '@/components/shared/Load-card.vue'
import config from '@/plugins/config'

//mixin
import { dashboardGraph } from '@/plugins/mixin/index.js'

// Register the necessary components
ChartJS.register(Title, Tooltip, Legend, ArcElement)

export default {
    name: 'DocumentTypeGraph',

    data() {
        return {
            chartData: {
                labels: [],
                datasets: [
                    {
                        label: 'My Dataset',
                        data: [],
                        backgroundColor: []
                    }
                ]
            },

            chartOptions: {
                responsive: true,

                maintainAspectRatio: false,

                onClick: (event, elements) => {
                    console.log('event', event)
                    if (elements.length > 0) {
                        const index = elements[0].index
                        const label = this.chartData.labels[index]
                        const color = this.chartData.datasets[0].backgroundColor[index]

                        this.selectedColor = color
                        this.$refs.dashboardModal.openModal(this.documents, label);
                    }
                },

                animation: {
                    duration: 1000, // Duración de la animación en milisegundos
                    easing: 'easeOutBounce' // Tipo de animación
                },
            },

            selectedColor: '',

            //data de documentos
            documents: [],

            load: true,

            connection: null
        }
    },

    mixins: [dashboardGraph],

    components: {
        DoughnutChart: Doughnut,
        AlertDismiss,
        DocumentTypeModal,
        LoadCard
    },

    async created() {
        this.connection = hub.getInstance(namesHub.documentHub)
        await this.connection.start();

        //signal R on - back to front
        this.allDocumentsSignalROn(this.connection);
    },

    beforeDestroy() {
        this.connection.off(ReceiveHubs.allDocumentsByDate, null);
    },

    methods: {
        allDocumentsSignalROn(connection) {
            connection.on(ReceiveHubs.allDocumentsByDate, (documents) => {
                try {
                    if (this.getGraph.mixinItUpdates){ this.processDocument(documents) }
                } catch (error) {
                    this.$refs.alertDismiss.showAlert("Error en la gráfica por tipos.");
                }

                this.load = false;
            });
        },

        handleChartClick(event) {
            console.log('evento metodo', event)
            // El evento ya se maneja en chartOptions.onClick
        },

        setChartData(nameTypeDocumentList, countTypeDocumentList, colors) {
            this.chartData = {
                labels: nameTypeDocumentList,
                datasets: [
                    {
                        label: 'Documentos',
                        data: countTypeDocumentList,
                        backgroundColor: colors
                    }
                ]
            }
        },

        //calcula el total de documentos segun el tipo 
        totalAccordingToType(documents) {
            const totalesPorTipo = documents.reduce((acumulador, document) => {

                const tipoDocumnet = document.type.name;

                if (!acumulador[tipoDocumnet]) {
                    acumulador[tipoDocumnet] = 0;
                }
                acumulador[tipoDocumnet]++;
                return acumulador;

            }, {});

            return totalesPorTipo;
        },

        separateNamesAndQuantities(totalesPorTipo) {
            const nombres = Object.keys(totalesPorTipo);
            const cantidades = Object.values(totalesPorTipo);

            // Ordenar por nombre
            const ordenadosPorNombre = nombres.map((nombre, index) => ({
                nombre: nombre,
                cantidad: cantidades[index]
            })).sort((a, b) => a.nombre.localeCompare(b.nombre));

            // Extraer los nombres y cantidades ordenados
            this.nameTypeDocumentList = ordenadosPorNombre.map(item => item.nombre);
            this.countTypeDocumentList = ordenadosPorNombre.map(item => item.cantidad);

            return {
                nameTypeDocumentList: this.nameTypeDocumentList,
                countTypeDocumentList: this.countTypeDocumentList
            }
        },

        //generar colores
        generateColorShades(baseColor, numShades) {
            const shades = []
            const color = tinycolor(baseColor)

            for (let i = 0; i < numShades; i++) {
                const shade = color.clone().lighten(i * 10).toString()
                shades.push(shade)
            }

            return shades
        },

        //separa cantidades y nombres, actualiza el render
        processDocument(documents) {
            this.documents = documents;

            if(this.documents == 0){
                this.setChartData(['Sin datos'], [0.1], [config.theme.menuBackgroundColor]);
                return
            }

            let totales = this.totalAccordingToType(this.documents);

            //separar cantidades y nombres de documentos
            let { nameTypeDocumentList, countTypeDocumentList } = this.separateNamesAndQuantities(totales);

            //colores
            let colors = this.generateColorShades(config.theme.menuBackgroundColor, nameTypeDocumentList.length);

            //actualizar render grafica
            this.setChartData(nameTypeDocumentList, countTypeDocumentList, colors);
        }
    }

}
</script>
<style></style>